import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import useUpdateMode from '@hooks/useUpdateMode'
import { saveAnswer } from '@utils/onboardingStorage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'

const QUESTION_KEY = 'v1_past_attempts'

const OPTIONS = [
  {
    value: 'Yes, multiple times',
    translationKey: 'pages.onboarding.pastAttempts.options.multipleTimes',
  },
  {
    value: 'Yes, but I gave up',
    translationKey: 'pages.onboarding.pastAttempts.options.gaveUp',
  },
  {
    value: 'Once or twice',
    translationKey: 'pages.onboarding.pastAttempts.options.onceTwice',
  },
  {
    value: 'No, this is my first time',
    translationKey: 'pages.onboarding.pastAttempts.options.firstTime',
  },
]

export default function PastAttemptsPage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const { isUpdate, postToReactNative } = useUpdateMode()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const value = formData.get('answer') as string

    if (!value) return

    const answer = {
      question_key: QUESTION_KEY,
      question: 'Have you tried to declutter before?',
      answer_key: value,
      answer: value,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(event.currentTarget)
    }
  }

  const buttons = OPTIONS.map((option) => ({
    text: t(option.translationKey),
    value: option.value,
  }))

  return (
    <QuestionPage
      heading={t('pages.onboarding.pastAttempts.heading')}
      buttons={buttons}
      onSubmit={handleSubmit}
      headingSize="text-3xl text-center whitespace-pre-line"
      buttonTextSize="text-xl"
      buttonBgColor="bg-white"
    />
  )
}
